﻿window.cBuilderEmailWidgetPerso = function(option) {
    var Me = this

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgetperso'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block",
            "position": "relative"
        })
        $DivBt.attr("tag", option.data.html)
        $DivBt.attr("tag2", option.data.id_widget_email)
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'></i>").appendTo($DivBt)
        var $DivTitle = $("<div style='font-family:barlow condensed;font-size:100%;align-items:center;justify-content:center;line-height:1;' class='ellipsismultiligne2'>" + option.data.nom + "</div>").appendTo($DivBt)
        $DivBt.attr("title", "<b>" + option.data.nom + "</b><br>" + option.data.description)

        var $TableBt = $("<table style='position:absolute;top:-10px;right:-10px;display:none;'/>").appendTo($DivBt)
        var $Tr = $("<tr/>").appendTo($TableBt)
        var $Td = $("<td/>").appendTo($Tr)
        var $divBtRename = $("<div />").appendTo($Td).dxCtrlButton({
            icon: "fas fa-pen",
            hint: "Modifier le nom du widget",
            width: 24,
            height: 24,
            onClick: function (e) {
                e.event.stopPropagation()
                var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                    target: e.component.element(),
                    width: 500,
                    showCloseButton: true,
                    shading: true,
                    contentTemplate: function (contentElement) {
                        contentElement.addClass("dx-theme-material-typography")
                        contentElement.css("padding", "20px")
                        contentElement.css("border", theme.border)

                        $("<div style='font-size:200%;'>Renimmer widget</div>").appendTo(contentElement)
                        var dxNom = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Nom du widget",
                            value: option.data.nom
                        }).dxCtrlTextBox("instance")
                        var dxDescription = $("<div style='margin:5px;'/>").appendTo(contentElement).dxCtrlTextBox({
                            labelMode: "floating",
                            label: "Description du widget",
                            value: option.data.description
                        }).dxCtrlTextBox("instance")
                        var $Div = $("<div style='text-align:right;'/>").appendTo(contentElement)
                        $("<div style='display:inline-block'/>").appendTo($Div).dxCtrlButton({
                            text: "Modifier le widget",
                            onClick: function (e) {
                                if (dxNom.option("value") == null || dxNom.option("value").length == 0) {
                                    mNotify("Veuillez saisir un nom pour le widget", "warning", 6000)
                                } else {
                                    option.data.nom = dxNom.option("value")
                                    option.data.description = dxDescription.option("value")
                                    $DivTitle.text(option.data.nom)
                                    $DivBt.attr("title", "<b>" + option.data.nom + "</b><br>" + option.data.description)

                                    option.bddCtrl.getObjet(option.data).mSave(function (data) {
                                        mNotify("Le widget '<b>" + dxNom.option("value") + "</b>' a été modifié.", "warning", 6000)
                                    })
                                    tt.hide()
                                }
                            }
                        })
                        dxNom.focus()
                    }
                }).dxCtrlTooltip("instance")
                tt.show()
            }
        }).dxCtrlButton("instance")
        var $Tr = $("<tr/>").appendTo($TableBt)
        var $Td = $("<td/>").appendTo($Tr)
        var $divBtDel = $("<div />").appendTo($Td).dxCtrlButton({
            icon: "fas fa-trash-alt",
            hint: "Mettre le widget personnalisé à la corbeille",
            width: 24,
            height: 24,
            onClick: function (e) {
                e.event.stopPropagation()
                $DivBt.parent().remove()
                option.bddCtrl.getObjet(option.data).mDelData(function () { })
            }
        }).dxCtrlButton("instance")

        $DivBt.off("mouseenter")
        $DivBt.on("mouseenter", function () { $TableBt.show() })
        $DivBt.off("mouseleave")
        $DivBt.on("mouseleave", function () { $TableBt.hide() })

        return $DivBt
    }

    this.mCreateElement = function () {
        //option.element = $("<!-- DEBUT WIDGET PERSO -->" + option.tag) //inégration du html du widgetperso
        //$("<!-- FIN WIDGET PERSO -->").appendTo(option.element)
        option.element = $(option.tag)
        $(option.element.find("tr")[0]).attr("id_widget_email",option.tag2)
    }

    this.nom = "Widget perso"
    this.icone = "fas fa-photo-film"

}